PaginationDirective.$inject = ['$location'];
function PaginationDirective($location) {
    return {
        template: require('./views/pagination.html'),
        scope: {
            total: '=',
            params: '='
        },
        link: function (scope, element, attrs) {
            scope.$watch('params', function (val) {
                scope.page = Number($location.search().page) || 1;
                scope.limit = val.count;
                scope.lastPage = scope.limit ? Math.ceil(scope.total / scope.limit) : scope.page;
                scope.from = (scope.page - 1) * scope.limit + 1;
                scope.to = Math.min(scope.total, scope.from + scope.limit - 1);
            });
            scope.setPage = function (page) {
                if (page > 1) {
                    $location.search('page', page);
                }
                else {
                    $location.search('page', null);
                }
            };
        }
    };
}
angular.module('profumo.core.directives.pagination', [])
    .directive('pagination', PaginationDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/PaginationDirective.js
// module id = 464
// module chunks = 0